const totalPeopleConfig = (dataArray) => {

  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false
    }
  };
  
  const dataPie = {
    labels: ['Total Mujeres', 'Total Hombres'],
    datasets: [{
      data: dataArray,
      backgroundColor: ['#A489D4','#4EC2F7'],
      hoverBackgroundColor: ["rgba(126,87,194,1)", "rgba(3,169,244,1)"],
      borderWidth: 5,
      hoverBorderColor: ['#fff', '#fff'],
    }]
  };
  
  
  return {
    type: 'doughnut',
    title: 'Datos demográficos',
    subtitle: 'Total de hombres y mujeres',
    data: dataPie,
    options: {
      ...sharedOptions,
      elements: {
        arc: {
          borderWidth: 5,
          borderColor: "#fff"
        }
      },
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          display: false
        },
      },
    }
  }

}

export default totalPeopleConfig;